import FormattedPrice from "@components/common/FormattedPrice";
import TransportTimeline from "@components/common/Timeline/TransportTimeline";
import { Journey, Transportation, Travel } from "@gen/travel/v1/common_pb";
import { priceOfJourney } from "@services/travel";
import { useBookingStore } from "@stores/useBookingStore";
import { Icon } from "@thetreep/ui";
import { formatLocalDateTime } from "@utils/formatDate";
import { useMemo } from "react";

export function CompactJourney({
  travel,
  journey,
  displayPrice,
}: {
  travel: Travel;
  journey: Journey;
  displayPrice?: boolean;
}) {
  const { searchRequest } = useBookingStore();
  const nbPassengers = (searchRequest?.additionalPassengers?.length ?? 0) + 1;

  const transport = journey.segments.reduce<Transportation>(
    (_, s) => s.transport?.type || Transportation.UNSPECIFIED,
    Transportation.UNSPECIFIED,
  );

  const price = useMemo(
    () => priceOfJourney(travel, journey),
    [travel, journey],
  );

  return (
    <div className="bg-white border border-grey-blue-300  rounded-lg w-full">
      <div className="p-4">
        <div className="flex justify-between gap-2">
          <div className="flex items-center gap-2">
            {transport === Transportation.TRAIN ? (
              <Icon src="train_4_line" size={24} color={"#3079F2"} />
            ) : (
              <Icon src="airplane_line" size={24} color={"#3079F2"} />
            )}
            <p className="text-sm text-text">
              {formatLocalDateTime(journey?.schedule?.departure)}
            </p>
          </div>
          <div className="flex items-center gap-2 text-sm text-strong ">
            {nbPassengers}
            <Icon src="user_4_fill" size={18} color={"#282828"} />
          </div>
        </div>
        <div className="mt-4">
          <TransportTimeline journey={journey} showDuration={false} />
        </div>
      </div>

      {displayPrice && (
        <div className="py-2 px-4 text-text border-t border-r-grey-blue-300">
          <div className="flex items-center justify-between">
            <div className="text-strong font-jakarta ">Total</div>
            <FormattedPrice
              integerSize={16}
              decimalSize={14}
              currency="€"
              isBold
              value={price}
            />
          </div>
        </div>
      )}
    </div>
  );
}
